import AppState from "../state";

const baseUrl = `${AppState.serverAddr}/funcionarios`;

const addFuncionario = funcionarioData => {
  return fetch(`${baseUrl}/AddFuncionario.php`, {
    method: "POST",
    headers: {
      Authorization: AppState.token
    },
    body: funcionarioData
  }).then(response => {
    if (!response.ok) {
      return response.json().then(json => {
        var error = new Error(response.status);
        error.response = json;
        throw error;
      });
    }

    const res = response.json();
    return res;
  });
};

const editFuncionario = funcionarioData => {
  return fetch(`${baseUrl}/EditFuncionario.php`, {
    method: "POST",
    headers: {
      Authorization: AppState.token
    },
    body: funcionarioData
  }).then(response => {
    if (!response.ok) {
      return response.json().then(json => {
        var error = new Error(response.status);
        error.response = json;
        throw error;
      });
    }

    const res = response.json();
    return res;
  });
};

const addDespesaPessoalFuncionario = funcionarios => {
  return fetch(`${baseUrl}/AddDespesasPessoaisFuncionarios.php`, {
    method: "POST",
    headers: {
      Authorization: AppState.token
    },
    body: JSON.stringify(funcionarios)
  }).then(response => {
    if (!response.ok) {
      return response.json().then(json => {
        const error = new Error(response.status);
        error.response = json;
        throw error;
      });
    }

    const res = response.json();
    return res;
  });
};

const getDespesasPessoaisFuncionarios = data => {
  return fetch(
    `${baseUrl}/GetDespesasPessoaisFuncionarios.php?filtro_data=${data}`,
    {
      method: "GET",
      headers: {
        Authorization: AppState.token
      }
    }
  )
    .then(response => {
      if (!response.ok) {
        return response.json().then(json => {
          const error = new Error(response.status);
          error.response = json;
          throw error;
        });
      }

      const res = response.json();
      return res;
    })
    .then(response => {
      return response.request;
    });
};

// --- Visao funcionario (Fase 0/2 do roadmap) ---------------------------------
// Areas de cadastro das tabelas novas: historico salarial datado, alocacao em
// projetos, ferias, 13o salario e desligamento. Os helpers abaixo evitam
// repetir o mesmo tratamento de erro em cada uma das funcoes.

const tratarResposta = response => {
  if (!response.ok) {
    return response.json().then(json => {
      const error = new Error(response.status);
      error.response = json;
      throw error;
    });
  }

  return response.json();
};

const buscarPorCpf = (arquivo, cpf) => {
  const query = encodeURIComponent(JSON.stringify({ cpf_funcionario: cpf }));

  return fetch(`${baseUrl}/${arquivo}?json=${query}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: AppState.token
    }
  }).then(tratarResposta);
};

const enviar = (arquivo, dados) => {
  return fetch(`${baseUrl}/${arquivo}`, {
    method: "POST",
    headers: {
      Authorization: AppState.token
    },
    body: JSON.stringify(dados)
  }).then(tratarResposta);
};

const getHistoricoSalarial = cpf => buscarPorCpf("GetHistoricoSalarial.php", cpf);
// Pede a mudança: ela fica pendente até um sócio aprovar.
const addSalarioHistorico = dados => enviar("AddSalarioHistorico.php", dados);

// Pedidos de mudança de salário. status: pendente (padrão), aprovada,
// recusada, cancelada ou todos. A resposta traz pode_aprovar (usuário é sócio).
const getSolicitacoesSalario = (status, cpf) => {
  const params = { status: status || "pendente" };
  if (cpf) params.cpf_funcionario = cpf;
  const query = encodeURIComponent(JSON.stringify(params));
  return fetch(`${baseUrl}/GetSolicitacoesSalario.php?json=${query}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: AppState.token
    }
  }).then(tratarResposta);
};

// decisao: 'aprovar' | 'recusar' (só sócio) | 'cancelar'.
const decidirSalario = (id, decisao, motivoRecusa) =>
  enviar("DecidirSalario.php", { id, decisao, motivo_recusa: motivoRecusa || "" });

// O histórico de alocação é gravado sozinho quando os projetos da pessoa são
// salvos em Sistema > Usuários, então aqui só existe a leitura.
const getAlocacoesProjeto = cpf => buscarPorCpf("GetAlocacoesProjeto.php", cpf);

const getFerias = cpf => buscarPorCpf("GetFerias.php", cpf);
const addFerias = dados => enviar("AddFerias.php", dados);

const getDecimoTerceiro = cpf => buscarPorCpf("GetDecimoTerceiro.php", cpf);
const addDecimoTerceiro = dados => enviar("AddDecimoTerceiro.php", dados);

// Alerta de prazo de férias. O cpf é opcional: sem ele devolve todos os casos
// (usado pela lista de funcionários), com ele devolve só aquela pessoa.
const getAlertasFerias = cpf => {
  const sufixo = cpf
    ? `?json=${encodeURIComponent(JSON.stringify({ cpf_funcionario: cpf }))}`
    : "";

  return fetch(`${baseUrl}/GetAlertasFerias.php${sufixo}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: AppState.token
    }
  }).then(tratarResposta);
};

const getDesligamento = cpf => buscarPorCpf("GetDesligamento.php", cpf);
const addDesligamento = dados => enviar("AddDesligamento.php", dados);

// CBOs que entram na base da cota de jovem aprendiz (tabela cbo_aprendiz).
const getCboAprendiz = () =>
  fetch(`${baseUrl}/GetCboAprendiz.php`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: AppState.token
    }
  }).then(tratarResposta);
const salvarCboAprendiz = (cbo, descricao, entraCalculo) =>
  enviar("SalvarCboAprendiz.php", { acao: "salvar", cbo, descricao, entra_calculo: entraCalculo });
const removerCboAprendiz = cbo => enviar("SalvarCboAprendiz.php", { acao: "remover", cbo });

export {
  getCboAprendiz,
  salvarCboAprendiz,
  removerCboAprendiz,
  addFuncionario,
  editFuncionario,
  addDespesaPessoalFuncionario,
  getDespesasPessoaisFuncionarios,
  getHistoricoSalarial,
  addSalarioHistorico,
  getSolicitacoesSalario,
  decidirSalario,
  getAlocacoesProjeto,
  getFerias,
  addFerias,
  getAlertasFerias,
  getDecimoTerceiro,
  addDecimoTerceiro,
  getDesligamento,
  addDesligamento
};
